import React from 'react';

const LegalSections = () => (
  <>
    <div className="pt-6">
      <h3 className="text-lg font-semibold text-white mb-3">
        Geschäftsführung & Inhaber
      </h3>
      <p className="text-slate-300">Floria Maler Sanierung / Floria Maler & Lackierer</p>
    </div>

    <div className="pt-6 border-t border-slate-700">
      <h3 className="text-lg font-semibold text-white mb-3">
        Tätigkeitsbereich
      </h3>
      <p className="text-slate-300 mb-3">
        Professionelle Malerarbeiten in der Schweiz und Deutschland mit Schwerpunkt auf:
      </p>
      <ul className="list-disc list-inside text-slate-300 space-y-1">
        <li>Wände und Decken streichen</li>
        <li>Wohnungen streichen beim Auszug</li>
        <li>Weißanstriche für Wohnungsübergaben</li>
        <li>Malerarbeiten für leere und möblierte Wohnungen</li>
      </ul>
    </div>

    <div className="pt-6 border-t border-slate-700">
      <h3 className="text-lg font-semibold text-white mb-3">
        Serviceregionen
      </h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <div className="font-semibold text-blue-400 mb-2">Schweiz</div>
          <p className="text-slate-300">
            Zürich, Winterthur, Uster, Dübendorf, Dietikon, Wetzikon, Basel und Umgebung
          </p>
          <p className="text-slate-300 mt-2">
            <strong className="text-white">Kantone:</strong> Thurgau, Zürich, Aargau, Basel
          </p>
        </div>
        <div>
          <div className="font-semibold text-purple-400 mb-2">Deutschland</div>
          <p className="text-slate-300">
            Stuttgart, Karlsruhe, Mannheim, Freiburg, Baden-Württemberg und Umgebung
          </p>
        </div>
      </div>
    </div>

    <div className="pt-6 border-t border-slate-700">
      <h3 className="text-lg font-semibold text-white mb-3">
        Haftungsausschluss
      </h3>
      <p className="text-slate-300 leading-relaxed">
        Der Autor übernimmt keine Gewähr für die Richtigkeit, Genauigkeit, Aktualität, 
        Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den 
        Autor wegen Schäden materieller oder immaterieller Art, die aus dem Zugriff oder der 
        Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der 
        Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.
      </p>
    </div>

    <div className="pt-6 border-t border-slate-700">
      <h3 className="text-lg font-semibold text-white mb-3">
        Urheberrechte
      </h3>
      <p className="text-slate-300 leading-relaxed">
        Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien 
        auf dieser Website gehören ausschliesslich Floria Maler Sanierung oder den speziell 
        genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche 
        Zustimmung des Urheberrechtsträgers im Voraus einzuholen.
      </p>
    </div>
  </>
);

export default LegalSections;
